import { render, staticRenderFns } from "./sticky-menu.vue?vue&type=template&id=3b475fb0&scoped=true&"
import script from "./sticky-menu.vue?vue&type=script&lang=js&"
export * from "./sticky-menu.vue?vue&type=script&lang=js&"
import style0 from "./sticky-menu.vue?vue&type=style&index=0&id=3b475fb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b475fb0",
  null
  
)

export default component.exports